import {
  ReactElement, createElement,
} from 'react';
import { Skeleton } from '@mui/material';
import { Info } from '@mui/icons-material';
import { MobileTooltip } from 'components/MobileTooltip';

interface Props {
  title: string | ReactElement;
  isLoading: boolean;
  // Usually the search text is rendered in an h1, but some pages may have a different h1 already
  headerNode?: 'h1' | 'h2' | 'h3' | 'h4';
  showMakeProjectButton?: boolean;
  makeAProject?: () => void;
  hideTitle?: boolean;
}

export const FilterPostTitle = ({
  title, isLoading = false, headerNode = 'h1', showMakeProjectButton = false, makeAProject, hideTitle = false,
}: Props) => {
  if (isLoading) {
    return <Skeleton variant="text" />;
  }
  return (
    <div className="md:text-lg w-full">
      <div className="w-full">
        <div>
          {title && (
            <div className="flex w-full">
              {(title && !hideTitle) && createElement(headerNode, null, title)}
              {showMakeProjectButton && (
                <button
                  type="button"
                  className="ml-3 btn-primary-outlined-xs"
                  onClick={makeAProject}
                >
                  Make a project
                  <MobileTooltip title="Add all the posts on this page of results to a project" placement="top" arrow>
                    <Info className="ml-1" color="secondary" fontSize="small" />
                  </MobileTooltip>
                </button>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
